import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";
import HqPackingListManagement from "@/views/inbound-management/HqPackingListManagement.vue";

const inboundManagementRoutes: RouteConfig[] = [
  {
    path: "/inbound-management",
    component: Layout,
    name: "InboundManagement",
    meta: {
      title: "inboundManagement",
      icon: "el-icon-circle-plus",
      alwaysShow: true,
    },
    children: [
      {
        path: ":type/:parentId/packing-list/",
        name: "DeliveryPackingList",
        component: () =>
            import("@/views/inbound-management/HqPackingListManagement.vue"),
        meta: {title: "packingListManagement", hidden: true}
      },
      {
        path: ":type/:parentId/packing-list/",
        name: "PackingList",
        component: HqPackingListManagement,
        meta: { title: "packingListManagement", hidden: true },
        props: true
      },
      {
        path: "delivery-note",
        name: "DeliveryNoteManagement",
        component: () =>
          import("@/views/inbound-management/DeliveryNoteManagement.vue"),
        meta: { title: "deliveryNoteManagement" },
      },
      {
        path: ":type/:parentId/packing-list/:hqPackingListId",
        name: "HqPackingListDetail",
        component: () =>
          import("@/views/inbound-management/HqPackingListDetail.vue"),
        meta: { title: "hqPackingListDetail", hidden: true },
      },
      {
        path: "delivery-note/:parentId/packing-list/:hqPackingListId/package-management",
        name: "HqPackingListPackageManagement",
        component: () =>
          import(
            "@/views/inbound-management/HqPackingListPackageManagement.vue"
          ),
        meta: { title: "packageManagement", hidden: true },
      },
      {
        path: ":type/:parentId/packing-list/:hqPackingListId/edit",
        name: "DeliveryHqPackingListDetailForEdit",
        component: () =>
          import("@/views/inbound-management/HqPackingListDetailForEdit.vue"),
        meta: { title: "editHqPackingList", hidden: true },
      },
      {
        path: "delivery-note/:parentId/packing-list/:hqPackingListId/confirm-scanning",
        name: "CustomsPackingConfirmScanning",
        component: () =>
          import(
            "@/views/inbound-management/CustomsPackingConfirmScanning.vue"
          ),
        meta: { title: "scanningConfirm", hidden: true },
      },
      {
        path: ":bizType/:objectId/image-management",
        name: "ImageManagement",
        component: () =>
          import("@/views/inbound-management/ImageManagement.vue"),
        meta: { title: "imageManagement", hidden: true },
      },
      {
        path: "hengan-loading-plan",
        name: "HenganLoadingPlanForWarehouse",
        component: () =>
          import(
            "@/views/warehouse-management/HenganLoadingPlanManagementForWarehouse.vue"
          ),
        meta: { title: "henganLoadingPlanForWarehouse" },
      },
      {
        path: "transship",
        name: "Transship",
        component: () => import("@/views/outbound-management/Transship.vue"),
        meta: { title: "transship", hidden: true },
      },
      {
        path: "hengan-loading-plan/:henganLoadingPlanId",
        component: () =>
          import(
            "@/views/warehouse-management/HenganLoadingPlanDetailForWarehouse.vue"
          ),
        name: "HenganLoadingPlanDetailForWarehouse",
        meta: { title: "henganLoadingPlanDetail", hidden: true },
      },
      {
        path: ":id",
        name: "HenganLoadingPlanDetail",
        component: () =>
          import("@/views/outbound-management/HenganLoadingPlanDetail.vue"),
        meta: { title: "henganLoadingPlanDetail", hidden: true },
      },
    ],
  },
];

export default inboundManagementRoutes;
